export default {
  namespaced: true,
  state: () => ({
    bookList: []
  }),
  mutations: {
    changeBookList(state, bookList) {
      state.bookList = bookList;
    }
  }
};
